
import React, { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loading from "../components/Loading/Loading";
import { useOidcUserContext } from "../contexts/OidcUserContext";
import { fetchAuthentication, setAuthentication } from "../actions";
import { RootState } from "../store";

const OidcToReduxSync = ({ children }: { children: ReactNode }) => {
    const dispatch = useDispatch();
    const { oidcUser, signoutRedirect } = useOidcUserContext();
    const { access_token, userId, forceLogout } = useSelector((state: RootState) => state.authentication);
    // const authenticationCall =
    //     useSelector((state: RootState) => state.apiCalls.fetchAuthentication["undefined"]) ||
    //     {};

    useEffect(() => {
        const access_token = oidcUser ? oidcUser.access_token : null;
        dispatch(setAuthentication({ access_token }));
    }, [oidcUser]);

    useEffect(() => {
        access_token && dispatch(fetchAuthentication());
    }, [access_token]);

    useEffect(() => {
        forceLogout && signoutRedirect();
    }, [forceLogout]);

    if (oidcUser && !userId) return <Loading />;
    // if (authenticationCall.isFetching) return <Loading />;

    return <>{children}</>;
};

export default OidcToReduxSync;
